/**
 * Returns a distinct set of array values.
 */
export function distinct<T>(arr: readonly T[]): T[]  {
  return Array.from(new Set(arr));
}